import CourseChecklist from './CourseChecklist';

export default CourseChecklist;
